// extracted by mini-css-extract-plugin
export default {"text":"text-field_text__ILdYp"};